import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsAdvancedRoadmapsHierarchyRoute: InvariantJiraRoute = {
	name: 'global-settings-products-advanced-roadmaps-hierarchy',
	path: '/secure/PortfolioHierarchy.jspa',
};
